module.exports = __webpack_public_path__ + "media/images/naver@2x-53c35643246eb2405a493735252669ae.png";